export default __webpack_public_path__ + "static/media/image3.16cef05d.svg";